// extracted by mini-css-extract-plugin
export var button = "_kb-0";